// Predefined security questions used across Register / ForgotPassword / Set-security-question modal
export const SECURITY_QUESTIONS = [
  "What is your mother's maiden name?",
  "What was the name of your first pet?",
  "What city were you born in?",
  "What is the name of your primary school?",
  "What was your childhood nickname?",
  "What is your favourite book?",
  "What was the make of your first car?",
  "What is the name of your best friend from childhood?",
];
